import { Dispatch, SetStateAction, useEffect, useState } from 'react';

type IDimensions = [width: number | null, height: number | null];

const useWindowDimensions = (): [
  dimensions: IDimensions,
  setDimenstions: Dispatch<SetStateAction<IDimensions>>
] => {
  const [dimensions, setDimensions] = useState<IDimensions>(() => {
    if (typeof window !== 'undefined') {
      return [window.innerWidth, window.innerHeight];
    }
    return [null, null];
  });

  useEffect(() => {
    const handleWindowResize = () => {
      setDimensions([window.innerWidth, window.innerHeight]);
    };

    window.addEventListener('resize', handleWindowResize);

    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, []);

  return [dimensions, setDimensions];
};

export default useWindowDimensions;
